function parseResponseData(data) {
  if((!data) || data.length==0){
      return null;
  }
  else {
    return JSON.stringify(data);
  }
}

function serviceFactory({ api }) {
  const getResponseJson = ({portfolioId, screen, context,metaData}) =>
    api
    .getResponseJson(portfolioId, screen, context, metaData)
    .then(parseResponseData);

  const getResponseJsonExtended = ({portfolioId, screen, context, investmentIdeaId,metaData}) =>
    api
    .getResponseJsonExtended(portfolioId, screen, context, investmentIdeaId, metaData)
    .then(parseResponseData);

    return {
      getResponseJson,
      getResponseJsonExtended
    }
}

module.exports = serviceFactory;